import { postJSON } from 'common/services/api'
import dayjs, { type Dayjs } from 'dayjs'
import useMixpanelEvent, { MixpanelEvents } from 'hooks/useMixpanelEvent'
import { useCallback } from 'react'

export type AbsenceHistoryFilters = {
  rangePicker?: [Dayjs | null, Dayjs | null] | null
  absenceType?: string
  users?: string[]
}

function mapFiltersToApi(filters: AbsenceHistoryFilters) {
  const mapped: Record<string, any> = {}

  if (filters.rangePicker?.[0]) {
    mapped.startDate = dayjs(filters.rangePicker[0])
      .startOf('day')
      .toISOString()
  }
  if (filters.rangePicker?.[1]) {
    mapped.endDate = dayjs(filters.rangePicker[1]).endOf('day').toISOString()
  }
  if (filters.absenceType) {
    mapped.absenceTypes = filters.absenceType
  }
  if (filters.users && filters.users.length > 0) {
    mapped.users = filters.users
  }

  return mapped
}

export function useExportAbsencesHistoryCsv(filters: AbsenceHistoryFilters) {
  const sendEvent = useMixpanelEvent()

  return useCallback(async () => {
    try {
      const mappedFilters = mapFiltersToApi(filters)
      const url = '/absences/export-history'

      const result = await postJSON({
        url,
        method: 'POST',
        isRota: true,
        responseType: 'arrayBuffer',
        body: JSON.stringify(mappedFilters)
      })
      if (!result) {
        alert('No data received from server')
        return
      }

      sendEvent(MixpanelEvents.ROSTERING_REPORT_DOWNLOADED, {
        reportType: 'absences',
        daysCovered:
          filters.rangePicker?.[0] && filters.rangePicker?.[1]
            ? dayjs(filters.rangePicker[1]).diff(
                dayjs(filters.rangePicker[0]),
                'day'
              ) + 1
            : 'all'
      })

      const blob = new Blob([result], { type: 'text/csv' })
      const filename = 'absences-history.csv'
      const blobUrl = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = blobUrl
      a.download = filename
      document.body.appendChild(a)
      a.click()
      a.remove()
      window.URL.revokeObjectURL(blobUrl)
    } catch (err) {
      console.error(err)
      alert('Failed to export CSV')
    }
  }, [filters, sendEvent])
}
